import React, { FC, memo } from 'react';
import cx from 'clsx';

import styles from './MenuItemImage.module.scss';
import { Item } from 'olo-service';
import { MENU_ITEM_TEST_ID } from 'routes/Menu/const';

export enum ImageSize {
  SMALL = 'small_1x1',
  MEDIUM = 'medium_1x1',
  LARGE = 'large_1x1'
}

const IMAGE_SIZE_STYLE_MAP: Record<ImageSize, string | undefined> = {
  [ImageSize.SMALL]: styles.small,
  [ImageSize.MEDIUM]: styles.medium,
  [ImageSize.LARGE]: styles.large
};

type MenuItemImageProps = React.HTMLAttributes<HTMLElement> & {
  item?: Item;
  imageSize?: ImageSize;
};

export const MenuItemImage: FC<MenuItemImageProps> = memo(function MenuItemImage({
  item, imageSize, className, children, ...props
}) {
  if (!item || !imageSize) return null;

  const { images } = item;
  const imageSource = images?.find(imageSrc => imageSrc.name === imageSize) || '';

  if (imageSource === '') return null;

  return (
    <div>
      <img src={imageSource.source} alt={`${item?.name}`} className={cx(styles.image, IMAGE_SIZE_STYLE_MAP[imageSize], className)} data-testid={`${MENU_ITEM_TEST_ID.image}-${imageSize}`} />
    </div>
  );
});
